import {
  ArraySerializer,
  Field,
  Type,
  Model,
  PrimitiveSerializer,
} from 'serialize-ts';

@Model()
export class SmartOffers {
  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  b2b: string[];

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  b2c: string[];
}

@Model()
export class CheapestOffers {
  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  b2b: string[];

  @Field()
  @Type(new ArraySerializer(new PrimitiveSerializer()))
  b2c: string[];
}

@Model()
export class SortedBestOffers {
  @Field()
  cheapest: CheapestOffers;

  @Field()
  smart: SmartOffers;
}
